export default __webpack_public_path__ + "static/media/small-cone.a1804d75.svg";